import { useTranslation } from 'react-i18next';

import ArrowRightLine from '@/assets/icons/arrow_right_line.svg?component';
import { Button } from '@/components/atoms/Buttons';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

const ARROW_ICON_SIZE = 20;

interface ViewButtonProps {
    /** The module page the card summarises. */
    to: string;
}

/** The "View →" action every card on the dashboard carries in its header. */
export default function ViewButton(props: ViewButtonProps) {
    const { to } = props;
    const { t } = useTranslation();

    return (
        <Button
            variant="secondary"
            // Named by the path alone: `to` carries the cage-scoped query (`?fg=…`).
            trackingId={`cage_dashboard_view_${to.split('?')[0].split('/').filter(Boolean).at(-1) ?? 'page'}`}
            to={to}
            iconEnd={
                <SvgIcon
                    color="currentColor"
                    icon={ArrowRightLine}
                    size="custom"
                    customSize={ARROW_ICON_SIZE}
                />
            }>
            {t('common.actions.view')}
        </Button>
    );
}
